import * as React from 'react'
import * as Styled from './Video.styles'

const Video = ({ url, iframe, poster, width, height }) => {
  const renderIframe = () => (
    // eslint-disable-next-line react/no-danger
    <Styled.IframeWrapper
      width={width}
      height={height}
      dangerouslySetInnerHTML={{ __html: iframe }}
    />
  )
  return iframe?.length > 0 ? (
    renderIframe()
  ) : (
    <Styled.Video className="leshen-video">
      {/* Disabling until we find out if we want captions, descriptions, etc. */}
      {/* eslint-disable jsx-a11y/media-has-caption */}
      <video controls srcLang="en" poster={poster}>
        <source src={url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </Styled.Video>
  )
}

export default Video
